var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApiAccessToken({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_23892_16767)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.83366 1.6665C3.53248 1.6665 1.66699 3.53199 1.66699 5.83317C1.66699 7.37543 2.50491 8.722 3.75033 9.44242V14.8691C3.75033 15.5503 3.75033 15.891 3.87719 16.1973C4.00406 16.5036 4.24492 16.7444 4.72663 17.2262L5.83366 18.3332L7.59048 16.5763C7.67151 16.4953 7.71205 16.4548 7.74566 16.4108C7.83392 16.2954 7.89046 16.1589 7.90968 16.0148C7.91699 15.96 7.91699 15.9027 7.91699 15.7881C7.91699 15.6953 7.91699 15.649 7.91208 15.6039C7.89919 15.4858 7.86118 15.3718 7.80062 15.2695C7.77752 15.2305 7.74969 15.1934 7.69404 15.1193L6.66699 13.7498L7.25033 12.9721C7.58073 12.5315 7.74593 12.3113 7.83147 12.0547C7.91699 11.7981 7.91699 11.5228 7.91699 10.9721V9.44242C9.16241 8.722 10.0003 7.37543 10.0003 5.83317C10.0003 3.53199 8.13484 1.6665 5.83366 1.6665Z",
    stroke: "#808191",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.83301 5.8335H5.84049",
    stroke: "#808191",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.833 11.6665H15.833C16.6096 11.6665 16.9978 11.6665 17.3042 11.7933C17.7125 11.9625 18.037 12.287 18.2062 12.6953C18.333 13.0017 18.333 13.3899 18.333 14.1665C18.333 14.9431 18.333 15.3313 18.2062 15.6377C18.037 16.046 17.7125 16.3705 17.3042 16.5397C16.9978 16.6665 16.6096 16.6665 15.833 16.6665H10.833",
    stroke: "#808191",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 4.1665H15.8333C16.6099 4.1665 16.9982 4.1665 17.3045 4.29337C17.7128 4.46253 18.0373 4.78699 18.2065 5.19536C18.3333 5.50165 18.3333 5.88994 18.3333 6.6665C18.3333 7.44307 18.3333 7.83135 18.2065 8.13765C18.0373 8.546 17.7128 8.8705 17.3045 9.03967C16.9982 9.1665 16.6099 9.1665 15.8333 9.1665H12.5",
    stroke: "#808191",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_23892_16767"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApiAccessToken);
export default __webpack_public_path__ + "static/media/api-access-token.0c46b11e2055551d239ada294b6b2b3f.svg";
export { ForwardRef as ReactComponent };